import { useEffect, useState } from 'react';

const refreshIntervalMilliseconds = 60_000;

export function useRelativeTimeRefresh(): void {
  const [, setRefreshTime] = useState(Date.now);

  useEffect(() => {
    const intervalId = window.setInterval(refreshRelativeTimes, refreshIntervalMilliseconds);
    return stopRelativeTimeRefresh;

    function refreshRelativeTimes(): void {
      setRefreshTime(Date.now());
    }

    function stopRelativeTimeRefresh(): void {
      window.clearInterval(intervalId);
    }
  }, []);
}
